import React from 'react';

/**
 * Compact wordmark + globe icon for header/footer use.
 * Editorial wordmark — no text-gradient, just clean type.
 */
export default function DestinationLogo({ height = 44 }) {
  return (
    <span
      className="destination-logo"
      style={{ display: 'inline-flex', alignItems: 'center', gap: 14, height }}
      aria-label="Destination Success, VMHS CTE Senior Awards"
    >
      <svg
        height={height}
        width={height}
        viewBox="0 0 44 44"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="22" cy="22" r="16" fill="none" stroke="var(--cloud)" strokeWidth="1.4" />
        <ellipse cx="22" cy="22" rx="16" ry="6" fill="none" stroke="var(--cloud)" strokeOpacity="0.55" strokeWidth="1" />
        <ellipse cx="22" cy="22" rx="6" ry="16" fill="none" stroke="var(--cloud)" strokeOpacity="0.55" strokeWidth="1" />
        <path
          d="M 7 18 Q 22 4 37 18"
          fill="none"
          stroke="var(--horizon-gold)"
          strokeWidth="1.4"
          strokeDasharray="2 3"
          strokeLinecap="round"
        />
        <g transform="translate(33 12) rotate(35)">
          <path d="M -3 0 L 3 0 M 0 -3 L 0 3" stroke="var(--horizon-gold)" strokeWidth="1.4" strokeLinecap="round" />
        </g>
      </svg>
      <span
        style={{
          fontFamily: 'var(--font-display)',
          fontWeight: 700,
          fontSize: height * 0.46,
          letterSpacing: '-0.005em',
          color: 'var(--cloud)',
          lineHeight: 1,
          whiteSpace: 'nowrap',
        }}
      >
        Destination: <span style={{ fontWeight: 700, color: 'var(--horizon-gold)' }}>Success</span>
      </span>
    </span>
  );
}
